/*!
 * Copyright (c) 2022 Digital Bazaar, Inc. All rights reserved.
 */
import {DataIntegrityProof} from './DataIntegrityProof.js';

export {DataIntegrityProof};
